'use strict';

/**
 * TinyMCE File Manager — url-окно через openModalUrl: контент — Blade-фрагмент по URL (GET /tinymce/files),
 * дропзона работает штатными делегированными обработчиками file-dropzone/*.js (drag/click/paste).
 * После загрузки/удаления файла содержимое окна перезагружается алиасом reload-content.
 */

// Экранирование для HTML-строки insertContent и сообщения окна подтверждения.
function esc(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

// Глобальная функция для вызова из TinyMCE.
window.openFileManagerModal = function (editor) {
    window.openModalUrl(null, {
        title: '<i class="fas fa-folder-open me-2"></i>Файловый менеджер',
        size: "md",
        url: '/tinymce/files',
        onAfterContentInsert: function (config) {
            let modal = config.modal;
            let listEl = modal.find(".fm-file-list");
            let fileInput = modal.find(".fm-file-input");
            let progress = modal.find(".file-dropzone-progress");
            let progressBar = progress.find(".progress-bar");

            // Повторно подгрузить фрагмент окна — свежий список файлов.
            function reloadContent() {
                window.openModalWindowFunctions["reload-content"](null, config);
            }

            // Загрузка файлов: drag / клик / вставка из буфера всё сходятся на change этого инпута.
            fileInput.on('change', function () {
                let files = Array.from(this.files);
                if (!files.length) return;

                this.value = '';

                progress.removeClass('d-none');
                progressBar.css('width', '0%');

                let total = files.length;
                let uploaded = 0;

                files.forEach(function (file) {
                    let form = new FormData();
                    form.append('file', file);

                    jQuery.ajax({
                        url: '/tinymce/files',
                        method: 'POST',
                        data: form,
                        processData: false,
                        contentType: false,
                        xhr: function () {
                            let xhr = new XMLHttpRequest();
                            xhr.upload.addEventListener('progress', function (e) {
                                if (e.lengthComputable) {
                                    progressBar.css('width', Math.round(((uploaded + e.loaded / e.total) / total) * 100) + '%');
                                }
                            });
                            return xhr;
                        },
                        success: function () {
                            // Список обновится единым reload-content после завершения всех файлов (см. complete).
                        },
                        error: function (xhr) {
                            let msg = 'Ошибка загрузки файла';
                            if (xhr.responseJSON && xhr.responseJSON.message) {
                                msg = xhr.responseJSON.message;
                            }
                            window.showToast(msg, 'danger');
                        },
                        complete: function () {
                            uploaded++;
                            if (uploaded === total) {
                                progress.addClass('d-none');
                                progressBar.css('width', '0%');
                                reloadContent();
                            }
                        },
                    });
                });
            });

            // Применить файл — вставить в редактор и закрыть окно.
            listEl.on('click', '.fm-insert', function () {
                let item = jQuery(this).closest('.fm-file-item');
                let url = item.data('url');
                let name = item.data('name');

                if (item.data('is-image')) {
                    editor.insertContent('<img src="' + esc(url) + '" alt="' + esc(name) + '">');
                } else {
                    editor.insertContent('<a href="' + esc(url) + '">' + esc(name) + '</a>');
                }

                modal.modal('hide');
            });

            // Удалить файл — через общее окно подтверждения.
            listEl.on('click', '.fm-delete', function () {
                let name = jQuery(this).closest('.fm-file-item').data('name');

                window.openConfirmModal({
                    message: 'Удалить файл «' + esc(name) + '»?',
                    callback: function () {
                        jQuery.ajax({
                            url: '/tinymce/files/' + encodeURIComponent(name),
                            method: 'DELETE',
                            success: reloadContent,
                        });
                    },
                });
            });
        }
    });
};
